import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 价格矩阵配置
export const setPriceMatrix: Mutation<IModuleState> = (state, payload) => {
  state.priceMatrix.data = payload.data;
  state.priceMatrix.loading = !!payload.loading;
};

// 所有增值服务列表
export const setModules: Mutation<IModuleState> = (state, payload) => {
  state.modules.data = payload.data;
  state.modules.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.active = payload.active;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
